import state from './onlineRoundtables.state';
import mutations from './onlineRoundtables.mutations';
import getters from './onlineRoundtables.getters';

export default {
  state,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/onlineRoundtables.store.js